window.addEventListener('DOMContentLoaded', (event) => {
  if ((window.location.href.indexOf("fr/creation?utm_source=partner&utm_medium=web&utm_campaign=infogreffe&utm_content=content") > -1)) {
    replaceHeaderWithImage('https://editor-assets.abtasty.com/48341/603d0b0d2c7211614613261.png');
    replaceFAQ('https://images.prismic.io/qonto/e1b9f2d3-7646-4789-85a0-7c88ede12065_infogreffe.png?auto=compress,format', 'https://www.infogreffe.fr/formalites-entreprise/formalites.html', 'Infogreffe', 1);
  }
});
